'use client';
import AppLayout from '@/components/AppLayout';
import PersonalProfilePage from './components/PersonalProfilePage';

export default function ProfilePage() {
  return (
    <AppLayout>
      <PersonalProfilePage />
    </AppLayout>
  );
}
